export default rawData => ({
    carteiraFundo: rawData.map(item => item.carteiraFundo),
    carteiraPatrimonio: rawData.map(item => item.carteiraPatrimonio),
    categories: rawData.map(item => [`${item.carteiraMes} ${item.carteiraAno}`]),
});
